import { DENTAL, LATITUDE, VISION_ID } from 'core/constants/products'
import detailsDentalFees from 'core/controllerPlans/detailsDentalFees'
import forEach from 'utils/DOM/forEach'
import getById from 'utils/DOM/getById'
import toggleClass from 'utils/DOM/toggleClass'
import moneyFormat from 'utils/format/money'
import tooltip from 'core/DOM/tooltip'
import textContent from 'utils/DOM/textContent'
import { Pivot } from 'types'
import { getLatitudeFees } from 'core/controllerPlans/getLatitudeFees'

function updateAddons(state: Pivot.State): void {
  toggleClass('.js-add-on-btn', 'remove', false)
  toggleClass('.js-latitude-btn', 'remove', false)

  forEach('.js-addon', node => {
    const [planId, addonId] = node.getAttribute('data-ids').split('-')
    const selectedAddons = state.addonsByPlan[planId] || []

    const isSelected = selectedAddons.includes(+addonId)
    const visionPlan = state.visionAddons[planId]
    const dentalPlan = state.dentalAddons[planId]
    const latitudePlan = state.latitudeAddons[planId]

    const isDental = state.plans[addonId].productId === DENTAL
    const isLatitude = state.plans[addonId].productId === LATITUDE

    node.dataset.spValue = `add ${isDental ? 'dental' : 'latitude'} ${addonId}`

    if (isSelected) {
      toggleClass(
        `.js-add-on-btn[data-ids="${[dentalPlan, visionPlan]
          .filter(Boolean)
          .join(',')}"]`,
        'remove',
        true
      )
      toggleClass(`.js-latitude-btn[data-ids="${latitudePlan}"]`, 'remove', true)

      node.dataset.spValue = `remove ${isDental ? 'dental' : 'latitude'} ${addonId}`
    }

    if (isDental) {
      const visionInput = getById(`vision-${planId}-addon-${addonId}`)

      const tooltipContent = detailsDentalFees(
        state.plans[addonId],
        visionInput.checked ? state.plans[VISION_ID] : undefined
      )

      const tooltipCost = $(`#tooltip-${planId}-${addonId}`)
      tooltip.initCustomTooltip({
        $holder: tooltipCost,
        customClass: 'hc-tooltip',
        content: tooltipContent
      })
    }

    if (isLatitude) {
      tooltip.initCustomTooltip({
        $holder: $(`#tooltip-${planId}-${addonId}`),
        customClass: 'hc-tooltip',
        content: getLatitudeFees(state.plans[addonId])
      })
    }
    toggleClass(`#addon-${planId}-${addonId}`, 'active', isSelected)
    node.checked = isSelected
  })

  Object.keys(state.addonsByPlan).forEach(planId => {
    const plan = state.plans[planId]
    if (plan) {
      textContent(`#planName-${planId}`, plan.title)
      textContent(`#value-${planId}`, plan.cost ? moneyFormat(plan.cost) : '--')
    }
  })
}

export default updateAddons
